import { LOCATION_MODE, GEOGRAPHICAL_MAP } from 'utils/constants/Map';
import { optionalFormField, getFormInitialValues } from 'utils/methods/helpers';
import { virtualPatrolFormFields, patrolFormFields } from 'utils/patrol';
import { transformEvidenceInitialValue } from 'utils/DataTransform/Task/taskForm';
import { EVIDENCE_PREFIX } from 'utils/constants/task';

export const defaultValues = {
  patrolDefinitionName: null,
  site: null,
  businessClient: null,
  expectedDuration: null,
};
export const getInitialValues = ({ values, defaultValues = {} }) => {
  if (!values) {
    return defaultValues;
  }

  const initialValues = getFormInitialValues(values);
  initialValues.siteName = values?.generalInfo?.site?.value;
  initialValues.businessClientName = values?.generalInfo?.businessClient?.value;

  const { checkPointDetail } = initialValues;
  let locationEvidence = null;

  const newCheckpoints = checkPointDetail?.map(
    ({ evidence, ...checkpoint }) => {
      if (!evidence || evidence.length < 1) return checkpoint;

      const key = EVIDENCE_PREFIX + checkpoint?.seqNumber;
      if (!locationEvidence) {
        locationEvidence = {};
      }
      if (!locationEvidence[key]) {
        locationEvidence[key] = null;
      }

      const value = transformEvidenceInitialValue({ evidence });

      locationEvidence[key] = { ...checkpoint, value };
      return checkpoint;
    },
  );

  if (checkPointDetail?.length > 1) {
    // compare the first and the last value in the array
    if (
      checkPointDetail[0].lat ===
        checkPointDetail[checkPointDetail.length - 1].lat &&
      checkPointDetail[0].lng ===
        checkPointDetail[checkPointDetail.length - 1].lng
    ) {
      // add returnToStart flag to true
      initialValues.returnToStart = true;
    } else {
      // add returnToStart flag to false
      initialValues.returnToStart = false;
    }
  } else {
    initialValues.returnToStart = false;
  }

  return {
    ...initialValues,
    checkpoints: newCheckpoints,
    locationEvidence: locationEvidence,
  };
};

export const clonePatrolDefInitialValues = ({
  patrolToCloneId,
  patrolToCloneDetails,
  defaultValues,
}) => {
  const clonedPatrol = getInitialValues({
    id: patrolToCloneId,
    values: patrolToCloneDetails,
    defaultValues,
  });

  return clonedPatrol;
};
// patrolDef object only contains definations of all the evidences attached.
// Combining it with virtualPatrolDetails which has info about the completed patrols
export const patrolDefWithCompletedPatrolValues = (
  patrolDef,
  virtualPatrolDetails,
) => {
  if (Object.keys(patrolDef) < 1) {
    return patrolDef;
  }
  if (virtualPatrolDetails && virtualPatrolDetails?.firstLocation?.timestamp) {
    const transformedLoc = virtualPatrolDetails?.locations.map((m, i) => {
      return { ...m, seqNumber: i + 2 }; // i starts from 0 and seqNumber 1 is already defined in first location
    });
    patrolDef.detailedInfo.patrolledLocations = {
      value: [
        { ...virtualPatrolDetails.firstLocation, seqNumber: 1 },

        ...transformedLoc,
      ],
    };
  }
  // if the evidence is timestamped, then it is completed
  return patrolDef;
};

export const generalSection = patrolDefDetails => {
  return [
    virtualPatrolFormFields.mobilePatrolIcon(
      patrolDefDetails?.others?.mobilePatrol?.value,
    ),
    virtualPatrolFormFields.patrolName,
    !patrolDefDetails?.others?.mobilePatrol?.value &&
      virtualPatrolFormFields.businessClient,
    !patrolDefDetails?.others?.mobilePatrol?.value &&
      virtualPatrolFormFields.site,
    virtualPatrolFormFields.scheduledStartTime,
    virtualPatrolFormFields.expectedDuration,
  ];
};

export const detailedSection = ({
  siteLocation,
  patrolDefDetails,
  uploadPatrolTask,
  surfaceImage,
}) => {
  const { checkpoints, returntostart } = virtualPatrolFormFields;
  const { checkpointsImage } = patrolFormFields;
  return [
    returntostart(patrolDefDetails?.detailedInfo?.returnToStart?.value),

    ...optionalFormField({
      showWhen: surfaceImage && surfaceImage.id !== GEOGRAPHICAL_MAP.id,
      field: checkpointsImage({
        selectedSiteDetailImages: surfaceImage,
        displayEvidence: true,
        uploadPatrolTask,
      }),
    }),
    ...optionalFormField({
      showWhen: surfaceImage && surfaceImage.id === GEOGRAPHICAL_MAP.id,
      field: checkpoints({
        additionalPolygon: siteLocation,
        additionalPolygonMode: LOCATION_MODE.HIGH_DETAIL,
        uploadPatrolTask,
      }),
    }),
  ];
};
